'use strict';exports.__esModule = true;var _slugify = require('slugify');var _slugify2 = _interopRequireDefault(_slugify);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var streetKeyRegexp = /((-street|-st|-|-st\.|-ulitsa)$)|^(vul-|vul\.-|vulytsya-)/gi;

var slugifyOptions = {
  lower: true,
  trim: true,
  strict: true };


var slugifyText = function slugifyText(text) {return (
    text &&
    (0, _slugify2.default)(text, slugifyOptions).
    replace(streetKeyRegexp, ''));};exports.default =

slugifyText;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/slugify.js
// module id = 99
// module chunks = 0